<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>
      <v-row class="pa-2" no-gutters>
        <custom-popup
          v-model="ready"
          :cons="{ title: $t('ready_card_samples') }"
          hide-confirm
          hide-overlay
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-sample-ready-card-visit-d`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('ready_card_sample')"
            />
          </template>
        </custom-popup>

        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1" :ripple="true">
              {{ $t("show_qr") }}
            </v-tab>
            <v-tab :ripple="true"> {{ $t("preview") }}</v-tab>
            <v-tab :ripple="true" :disabled="e6 <= 1">تعرفه‌ها</v-tab>
          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <qr-maker :loading="loading" />
              <!--          <v-btn class="btn-download" @click="showDialog=true">-->
              <!--            <v-icon>mdi-progress-download</v-icon>-->
              <!--            {{ $t('download_qr_comment') }}-->
              <!--          </v-btn>-->
            </v-tab-item>

            <v-tab-item>
              <view-multi-card :value="multiCard" :qr-svg-data-url="qrSvgDataUrl"/>
            </v-tab-item>
            <v-tab-item>
              <component :is="theme" v-model="multiCard" :data="multiCard" />
            </v-tab-item>
            <v-tab-item v-if="!!info?.id && e6>1">
                <Tariffs :id_qr="info.id" :qrtype="'multicard'" />
             </v-tab-item>

          </v-tabs-items>
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-row class="pa-2" justify="start" style="width: 100%">
            <v-col
              cols="12"
              sm="12"
              md="6"
              class="box"
              v-if="e6 === 1 && showconnect"
            >
              <v-text-field
                v-model="connectionCode"
                class="connect rounded-lg compact-text-field"
                dense
                :label="$t('connection_code')"
                outlined
                clearable
              >
              </v-text-field>
            </v-col>
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <v-row no-gutters>
                  <v-col class="pa-2" cols="12">
                    <p>وارد کردن اطلاعات مولتی کارت</p>
                  </v-col>

                  <v-col class="pa-2 d-flex row rowinfo" cols="12" md="6">
                    <v-text-field
                      v-model="multiCard.visitName"
                      :disabled="e6 > 1"
                      :error-messages="errors['title']"
                      append-icon="mdi-pen"
                      class="mt-0 pt-0 contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      label="نام مولتی کارت"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-visitName`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('visit_card_name')"
                    />
                  </v-col>

                  <v-col class="pa-2 rowinfo" cols="12" md="6">
                    <qr-address-field
                      id="qr-address"
                      ref="address-field"
                      v-model="dtUrl"
                      :disabled="e6 > 1"
                      :error-messages="errors['identifier']"
                      append-icon="mdi-web"
                      class="ma-0 pa-0 contentinfo"
                      width="88%"
                      dense
                      outlined
                      persistent-hint
                      @updateDest="domainId = $event"
                      :key="$t('qrAddressUpdate.hints.allowedChars')"
                      :hint="$t('qrAddressUpdate.hints.allowedChars')"

                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-dtUrl`"
                      :label="$t('qr_address')"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                    />
                  </v-col>
                </v-row>
              </v-stepper-step>
              <v-stepper-content step="1">
                <div class="col-md-12">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="markQr"
                  />
                </div>
              </v-stepper-content>

              <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
                {{ $t("info") }}
              </v-stepper-step>
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
               
                <!-- <div class="d-flex row ma-0 px-2 algin-start flex-nowrap"> -->
                <div class="d-flex row mx-2 mt-3 mb-4 justify-start doublebtn">
                  <v-btn
                    :disabled="e6 > 2"
                    class="mx-0"
                    color="third"
                    outlined
                    @click="clearDefaults"
                  >
                    <v-icon class="me-2">mdi-delete</v-icon>
                    {{ $t("remove_default_info") }}
                  </v-btn>
                  <help-info
                    class="buttoninfo mx-0"
                    :element-name="`${serviceName}-${componentName}-clearDefaults`"
                    :label="$t('remove_default_info')"
                    :service-name="serviceName"
                    :help-data="helpData"
                  />
                </div>
                  <div class="mb-4 mx-4">
                    <!-- سوییچ و آیکون راهنما -->
                    <div class="d-flex align-center">
                      <v-switch
                        v-model="AutoSave"
                        color="primary"
                        class="mt-0 pt-0 shrink"
                        hide-details
                        label="ذخیره خودکار"
                      ></v-switch>

                      <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="mr-1"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop
                          >
                            <v-icon small color="grey darken-1">
                              mdi-help-circle-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>
                          تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                        </span>
                      </v-tooltip>
                    </div>

                    <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                    <div
                      v-if="$vuetify.breakpoint.xsOnly"
                      class="text-caption grey--text text--darken-1 mt-1 pr-1"
                      style="line-height: 1.4"
                    >
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                    </div>
                  </div>

                <list-expansion
                  v-model="multiCard"
                  :components="specialInfo"
                  :data="multiCard"
                  flat
                  @save-required="AutoSave && qrUpdate(false)"
                />
                <div class="col-md-12">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="qrUpdate(true)"
                  />
                </div>
              </v-stepper-content>
            </v-stepper>

            <div class="d-none">
              <qr-code-make
                ref="qrCanvas"
                v-model="qrDesign"
                :file.sync="qrSvgDataUrl"
                :link="fullLink"
                @save="qrDesign = $event"
              />
            </div>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { mapActions } from "vuex";
import QrGenerator from "@/view/pages/qrland/components/qrGenerator";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import { Bus } from "@/main";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import ListExpansion from "../../content/fragments/listExpansion";
import NextBtn from "../../content/fragments/nextBtn";
import PrevBtn from "../../content/fragments/prevBtn";
import QrAddressField from "../../content/fragments/qrAddressField";
import VisitThemeTwo from "@/view/pages/qrland/components/themes/visitThemeTwo";
import ThemeSelector from "@/view/pages/qrland/components/themes/themeSelector";
import VisitThemeFlipped from "@/view/pages/qrland/components/themes/visitThemeFlipped";
import PreparedCards from "@/view/pages/qrland/preparedCards";
import MobileViwer from "@/view/pages/qrland/components/mobileViwer.vue";
import DownloadFile from "@/view/pages/qrland/downloadFile.vue";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import { getLanguageCookie } from "@/core/plugins/TitleRibbon/utils/languageCookie";
import ViewMultiCard from "@/view/pages/multiCart/viewMultiCard.vue";
import Tariffs from "../../components/Tariffs/Tariffs.vue";
import { AtomSpinner } from "epic-spinners";


export default {
  name: "multiCard",

  components: {
    ViewMultiCard,
    QrCodeMake,
    PreparedCards,
    ThemeSelector,
    VisitThemeTwo,
    VisitThemeFlipped,
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrManagement,
    DownloadFile,
    QrCustomize,
    QrMaker,
    QrGenerator,
    MobileViwer,
    Tariffs,
    AtomSpinner
  },


  data() {
    return {
      isAutoSaving: false, 
      AutoSave:false,
      loading: false,
      multiCard: {
        language: "fa",
        langs: {
          source_lang: "fa",
          other_langs: [],
        },
        infoUser: {
          nameCollection: "",
          subTitle: "",
          logoImage: "/media/defaults/qrLogo.webp",
          background: "/media/defaults/visitFirstDefault.webp",
        },
        cardBank: {
          list: [],
        },
        theme: "",
        visitName: "",
        pallete: {
          bodyColor: "linear-gradient(to top right , #AA7630FF, #EBCB63FF)",
          textColor: "#EBCB63FF",
          buttonColor: "linear-gradient(to top right , #AA7630FF, #EBCB63FF)",
        },
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      },
      helpData: [],
      componentName: "multicard",
      serviceName: "Qrland",
      qrDesign: {},
      e6: 1,
      errors: {},
      createdId: null,
      createdDomain: null,
      dtUrl: null,
      domainId: null,
      qrShow: 1,
      qrSvgDataUrl: "",
    };
  },

  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
    this.multiCard.visitName = "مولتی کارت";

    Bus.$on("showconnect", (val) => {
      this.showconnect = val;
    });
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },
  },

  computed: {
    specialInfo() {
      return [
        {
          name: "AddAccount", // name of component
          value: "",
          // title: this.$t("user_info"),
          title: "افزودن اطلاعات کاربر",
          subtitle: "",
          icon: "account-outline",
          model: "infoUser",
        },
        {
          name: "ManagementAccount", // name of component
          value: "",
          // title: this.$t("user_info"),
          title: "مدیریت حساب ها",
          subtitle: "",
          model: "cardBank",
          icon: "credit-card-outline",
        },
        {
          name: "ManagementColor",
          // title: this.$t("add_audio_file"),
          title: "مدیریت رنگ",
          icon: "palette",
          model: "pallete",
        },
      ];
    },

    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
    markQr() {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error(this.$t("invalid_qr_address"));
        return;
      }

      this.loading = true;
      this.multiCard.language = getLanguageCookie()
        ? getLanguageCookie()
        : "fa";
      this.multiCard.langs = {
        source_lang: this.multiCard.language,
        other_langs: [],
      };
      let obj = {
        type: "multicard",
        qrType: "dynamic",
        title: this.multiCard.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          data: this.multiCard,
        }),
        qr: JSON.stringify(this.qrDesign),
      };

      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.createdId = data.data.identifier;
          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId,
          ).name;
          this.info = data.data;
          this.setCreatedQrID(data.data.id);
          this.$toast.success("کیوآر مولتی کارت شما با موفقیت ساخته شد.");
          if (this.e6 === 1) {
            this.e6 = 2;
            this.qrShow = 0;
            this.$nextTick(() => {
              setTimeout(() => {
                console.log("this.$refs: ", this.$refs);

                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate(false);
                this.qrShow = 1;
              }, 2000);
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.status === 422)
            this.$modal.error("خطا", response.data.message);
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};
          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "multicard");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("_method", "PUT");
      data.append("qr", JSON.stringify(this.qrDesign));
      data.append("qr_id", this.info.qrId);
      this.multiCard.language = getLanguageCookie()
        ? getLanguageCookie()
        : "fa";

      data.append(
        "data",
        JSON.stringify({
          theme: this.theme,
          data: this.multiCard,
        }),
      );
      let finaldata = {
        theme: this.theme,
        data: this.multiCard,
      };
      let allLangs = [];
      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then(({ data }) => {
          if (final) {
            this.info = data.data;
            allLangs = [
              this.multiCard.language,
              ...(this.multiCard.langs?.other_langs).map((l) => l.lang),
            ];
            if (allLangs.length > 0 && final) {
              this.$api
                .post(`/v1/testQr/update-lang-data/${data.data.id}`, {
                  data: finaldata,
                  langs: allLangs,
                })
                .then((data) => {
                  // this.goto("qr/list");
                  // this.qrShow = 0;
                })
                .catch((err) => {})
                .finally(() => {
                  this.loading = false;
                  this.$toast.success(
                    "کیوار مولتی کارت شما با موفقیت ویرایش شد.",
                  );
                });
            }
          }
        })
        .catch((err) => {})
        .finally(() => {
          if (final) {
            this.goto("qr/list");
            this.qrShow = 0;
          }
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
    clearDefaults() {
      this.$root.$emit("clearDefaultData");
      this.multiCard.visitName = "";
      this.multiCard.apiKey =
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg";
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}

.help-info-wrapper {
  display: inline-block;
  vertical-align: middle;
  margin-left: 1px;
}

qr-address-field {
  width: 88% !important;
}

.warp {
  position: relative;
  overflow: visible !important;
  min-height: 50px;
}

.doublebtn {
  gap: 8px;
}

.connect >>> .v-input__append-outer {
  display: flex;
  align-items: center;
  margin: 0 !important;
  padding: 0 5px 0 5px !important;
}
</style>
